import { render, staticRenderFns } from "./addSinglePayment.vue?vue&type=template&id=897d72b6&scoped=true&"
import script from "./addSinglePayment.vue?vue&type=script&lang=js&"
export * from "./addSinglePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897d72b6",
  null
  
)

export default component.exports